{
  "header": {
    "id": "ID",
    "firstname": "Nome",
    "lastname": "Cognome",
    "profile": "Profilo",
    "profiles": "Profili",
    "email": "E-mail",
    "description": "Descrizione",
    "sector": "Rete",
    "sectors": "Reti",
    "group": "Gruppo",
    "groups": "Gruppi",
    "user": "Utente",
    "users": "Utenti",
    "application": "Applicazione",
    "applications": "Applicazioni",
    "equipment": "Apparato",
    "equipments": "Apparati",
    "label": "Nome",
    "nbUsers": "Numero utilizzatori",
    "userGroup": "Gruppo",
    "userGroups": "Gruppi",
    "device": "Apparato",
    "devices": "Apparati"
  }
}
